import { useContext } from 'react';
import {
  TEDSYSBokfarLASTEnum,
  TEDSYSBokfPeriodLASTEnum,
} from '../../../../../../globalQueryTypes';
import { getYear } from '../../../../../../Utils/dateUtils';
import {
  IFieldValidation,
  IValidateFn,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { BokforderWrapperContext } from '../../../Rutiner/Bokforder/Contexts/BokforderWrapperContext';
import { BokforderType } from '../Queries/_QueryTypes/BokforderType';

const useValidateBokfar: () => IValidateFn<BokforderType> = () => {
  const bokforderWrapperContext = useContext(BokforderWrapperContext);

  return ({ currentValues, touched }) => {
    const today = new Date();
    const errors: IFieldValidation[] = [];

    const bokfDate = new Date(currentValues.BOKF_DATUM);

    const selectedBokfar = bokforderWrapperContext.allBokfar.find(year => {
      const bokfar = new Date(year.BOKF_AR);

      return getYear(bokfar) === getYear(bokfDate);
    });

    if (selectedBokfar?.LAST === TEDSYSBokfarLASTEnum.LAST) {
      const yearError: IFieldValidation = {
        fieldName: 'BOKF_DATUM',
        message: 'Bokföringsåret är låst',
        type: 'Error',
      };
      errors.push(yearError);
    } else {
      const selectedPeriod =
        selectedBokfar?._Associations?.Bokfperiod_All?.find(period => {
          const periodFromDate = new Date(period.FRAN_DATUM);
          const periodToDate = new Date(period.TILL_DATUM);

          return periodFromDate <= bokfDate && periodToDate >= bokfDate;
        });

      if (selectedPeriod?.LAST === TEDSYSBokfPeriodLASTEnum.LAST) {
        const periodError: IFieldValidation = {
          fieldName: 'BOKF_DATUM',
          message: 'Bokföringsperioden är låst',
          type: 'Error',
        };
        errors.push(periodError);
      }
    }

    if (bokfDate > today) {
      const dateError: IFieldValidation = {
        fieldName: 'BOKF_DATUM',
        message:
          'Du kan bara välja bokföringsdatum fram till och med dagens datum',
        type: 'Error',
      };
      errors.push(dateError);
    }

    return errors;
  };
};

export default useValidateBokfar;
